module.exports = __webpack_public_path__ + "static/media/r15.06ecb0aa.jpg";